<!-- App.vue or your main component -->
<template>
  <div>
    <!-- Section Visibility Controls -->
    <div class="section-controls">
      <div class="grid-item">
        <h3>Select Sections to Display</h3>
        <div class="checkbox-group">
          <label class="checkbox-label">
            <input type="checkbox" v-model="showHomeSection" />
            <span>&nbsp;Home Section&nbsp;&nbsp;</span>
          </label>
          <label class="checkbox-label">
            <input type="checkbox" v-model="showF2L" />
            <span>&nbsp;F2L Section&nbsp;&nbsp;</span>
          </label>
          <label class="checkbox-label">
            <input type="checkbox" v-model="showOLL" />
            <span>&nbsp;OLL Section&nbsp;&nbsp;</span>
          </label>
          <label class="checkbox-label">
            <input type="checkbox" v-model="showPLL" />
            <span>&nbsp;PLL Section&nbsp;&nbsp;</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Sections -->
    <HomeSection v-if="showHomeSection" />
    <F2LSection v-if="showF2L" />
    <OLLSection v-if="showOLL" />
    <PLLSection v-if="showPLL" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import F2LSection from './F2LSection.vue';
import PLLSection from './PLLSection.vue';
import OLLSection from './OLLSection.vue';
import HomeSection from './HomeSection.vue';

const showHomeSection = ref(true);
const showF2L = ref(true);
const showOLL = ref(true);
const showPLL = ref(true);
</script>

<style>
.buy a {
  color: #fff;
}
.buy a:hover {
  text-decoration: none;
  color: #44a8f2;
}
div.buy {
  display: inline-block;
  margin-top: 20px;
  height: 50px;
  font-size: 20px;
  line-height: 48px;
  text-align: center;
  background-color: #44a8f2;
  border: 2px solid #44a8f2;
  padding: 0 15px;
}
div.buy:hover {
  background-color: rgba(0, 0, 0, 0);
  background-color: #fff;
  transition: background-color 0.3s;
  -moz-transition: background-color 0.3s; /* Firefox 4 */
  -webkit-transition: background-color 0.3s; /* Safari 和 Chrome */
  -o-transition: background-color 0.3s; /* Opera */
  border: 2px solid #44a8f2;
  color: #44a8f2;
  cursor: pointer;
}
.buy:hover a {
  color: #44a8f2;
}

.buyActive {
  /* background-color: #28a745 !important; */
  background-color: navy !important;
  /*font-weight: bolder;*/
  color: blue !important;
}
.scramble {
  /* color: #f08200 !important; */
  /* color: #d636db !important; */
  color: rgb(62, 8, 161);
  padding-top: 20px;
}

.scramblok {
  /* color: #f08200 !important; */
  /* color: #d636db !important; */
  background-color: rgba(183, 255, 0, 0.447) !important;
  padding: 2px !important;
  color: black;
}

.scramble_orange {
  /* color: #f08200 !important; */
  /* color: #d636db !important; */
  background-color: rgba(251, 122, 2, 0.578) !important;
  padding: 2px !important;
  color: black;
}

.scramble_learn {
  background-color: rgba(251, 2, 2, 0.579) !important;
  padding: 2px !important;
  color: black;
}

.rotate90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

.rotate180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.img_btn {
  vertical-align: middle;
  display: table-cell;
  margin-right: 6px !important;
}

.img_span {
  /* vertical-align: middle; */
  display: table-cell;
}

.selectedImg {
  background-color: hsla(206, 87%, 61%, 0.65);

  /* background-color: hsla(33, 100%, 47%, 0.5); */
}

.exampleImg {
  padding-bottom: 20px;
}

img {
  margin-right: 10px;
}

.white-text {
  color: #eee;
}

.white-text:hover {
  color: #44a8f2;
}

.section {
  margin: 0 auto 20px;
  padding: 16px 0px;
}

.grid-container {
  display: grid; /* Enables grid layout */
  grid-template-columns: repeat(
    4,
    1fr
  ); /* 3 columns, each taking equal space */
  gap: 10px; /* Adds spacing between grid items */
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

  letter-spacing: 3px;
}

.grid-container7 {
  display: grid; /* Enables grid layout */
  grid-template-columns: repeat(
    7,
    1fr
  ); /* 3 columns, each taking equal space */
  gap: 10px; /* Adds spacing between grid items */
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

  letter-spacing: 3px;
}

.grid-item {
  background-color: #f4fbfe;
  padding: 10px; /* Adds padding inside each grid item */
  text-align: center; /* Centers text inside grid items */
  color: #f08200;
  border: 2px solid #f08200;
  font-weight: bold;
  border-radius: 6px;
}

/* .grid-item .orderNum {
  font-size: 16px;
} */

.grid-title {
  color: red;
  padding-bottom: 10px;
}

@media (max-width: 800px) {
  .grid-container {
    grid-template-columns: 1fr; /* Single column layout for smaller screens */
  }
}

.mainColor {
  color: #f08200;
}

.mainColor2 {
  color: #0075ce;
}

.mainColor3 {
  color: #e50012;
}

.exampleText {
  color: black;
  margin-bottom: 1px !important;
}

.exampleTextNormal {
  color: black;
  font-weight: normal;
}

a {
  color: #f08200;
}

/* html {
  scroll-behavior: smooth;
} */
</style>
